import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LEARNING_MENU } from '../../config/learningNav';

export default function AdaptiveQuickNav() {
  const { pathname } = useLocation();
  const links = LEARNING_MENU.filter((item) => item.path !== pathname).slice(0, 4);
  if (!links.length) return null;

  return (
    <nav className="adaptive-quick-nav" aria-label="Related learning tools">
      <span className="adaptive-quick-nav-label">Explore</span>
      <div className="adaptive-quick-nav-links">
        {links.map((item) => (
          <Link key={item.path} to={item.path} className="adaptive-quick-nav-link">
            {item.shortLabel || item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
